module.exports = __webpack_public_path__ + "img/LV40003372253.0386056e.png";